export const PLACES_CATEGORIES = [
  "Acrylic Store",
  "Apartment Building",
  "Attraction",
  "Auto Repair Shop",
  "Bakery",
  "Baking Supply Store",
  "Bank",
  "Bar",
  "Basketball Court",
  "Bean Sprout & Soybean Sprout",
  "BMW Showroom",
  "Boarding School",
  "Bridal Shop",
  "Bridge",
  "British Council School Centre",
  "Business Centre",
  "Business Park",
  "Cafe",
  "Car Dealer",
  "Car Mart",
  "Cell Phone Store",
  "Children Park",
  "Chinese Language School",
  "Church",
  "Civil Service Club",
  "Clothing Brand Store",
  "Club",
  "College",
  "Community Center",
  "Community Centre",
  "Community Club",
  "Community Cemtre",
  "Computer Store",
  "Convenience Store",
  "Cooking Supply Store",
  "Corporate Office",
  "Court",
  "Cultural Centre",
  "Education",
  "Education Center",
  "Educational Institute",
  "Educational Office",
  "Electronics Manufacturer",
  "Electronics Store",
  "Employee Agency",
  "Embassy of China",
  "Embassy of Indonesia",
  "Embassy of Israel",
  "Embassy of Japan",
  "Entertainment",
  "Fashion Accessories Store",
  "Fast Food Centre",
  "Fire Station",
  "Florist",
  "Flower Shop",
  "Food",
  "Food and Beverage Consultant",
  "Food Cafe",
  "Food Center",
  "Food Centre",
  "Furniture Store",
  "Gasoline Station",
  "Garden",
  "Garden Centre",
  "Gift Shop",
  "Golf Club",
  "Government",
  "Government Office",
  "Grocery",
  "Grocery Store",
  "Health",
  "Health Food Store",
  "Heritage Building",
  "High Commission",
  "Historical Landmark",
  "Hospital",
  "Hotel",
  "Industry",
  "Industrial Building",
  "Institute",
  "Institute of Technology (SIT@NP)",
  "International School",
  "Intervention Centre",
  "Jewelry",
  "Jewellery Store",
  "Kindergarten",
  "Kindergarten School",
  "Korean Grocery Store",
  "Lake View Point",
  "Learning Institute",
  "Learning School",
  "Library",
  "Lottery Retailer",
  "Mall",
  "Mandai Executive Golf Course",
  "Market",
  "Market and Food Centre",
  "Mart",
  "Medical Clinic",
  "Minister Defense Office",
  "Ministry of Education",
  "Mosque",
  "Motor Scooter Dealer",
  "Motorcycle Dealer",
  "Motorcycle Shop",
  "Movie Theater",
  "Museum",
  "Music",
  "National Service Department",
  "Nature",
  "Natures Park",
  "Near Bus Station",
  "Near Central Mall",
  "Non-Profit Organization",
  "Office",
  "Outdoor Clothing and Equipment Shop",
  "Park",
  "Parking Area",
  "Pet Store",
  "Photography",
  "Photography Studio",
  "Pizza Shop",
  "Playground",
  "Police Headquarter",
  "Post Office",
  "Primary School",
  "Prison",
  "Public Housing",
  "Public Library",
  "Railroad Company",
  "Residence",
  "Residential Area",
  "Restaurant",
  "SAF Medical Training Institute",
  "School",
  "Secondary School",
  "Security Coordination Centre",
  "Shop",
  "Shopping",
  "Shopping Center",
  "Shopping Centre",
  "Shopping Mall",
  "Shopping Mart",
  "Showroom",
  "Society",
  "Software Company",
  "Sport",
  "Sports Centre",
  "Sports Club",
  "Sports Complex",
  "Sports Hall",
  "Station",
  "Super Market",
  "Swimming Club",
  "Swimming Complex",
  "Swimming Pool",
  "Tea Shop",
  "Temple",
  "Theater",
  "Thrift Store",
  "Tire Shop",
  "Tourism Court",
  "Town Council",
  "Toy Store",
  "Training Academy & Recruitment Centre",
  "Train",
  "Uniform Store",
  "University",
  "War Museum",
  "Water Treatment Plant",
  "ATM",
  "Bus Station",
  "Company",
  "Cemetery",
];
